export default {
  crypto: 'Crypto',
  cryptoWithdraw: 'Crypto करने के लिए',
  applicationDialogTitle: 'Crypto निकासी जानकारी आवेदन',
  phoneNumber: 'मोबाइल नंबर',
  email: 'ईमेल',
  usdtAddress: 'USDT पता',
  usdtChain: 'USDT चैन',
  applyWithdrawAmount: 'निकासी राशि',
  apply: 'आवेदन करना',
  withdrawApplySuccess: 'Crypto निकासी आवेदन सफलतापूर्वक सबमिट किया गया।',
  recordTip: 'निकासी इतिहास जांचने के लिए क्लिक करें',
  tip: 'बख्शीश:विथ्ड्रॉअल विफलता से बचने के लिए कृपया सही बैंक जानकारी प्रदान करें',
  phoneNum: 'फ़ोन नंबर',
  phoneError: 'कृपया सही फ़ोन नंबर दर्ज करें',
  holderName: 'खाता धारक का नाम',
  holderNameError: 'कृपया बैंक खाताधारक का नाम दर्ज करें',
  bankNumbervalidator:
    'प्रारूप गलत है, कृपया सुनिश्चित करें कि आपके द्वारा दर्ज किया गया नंबर सही है',
  holderNamevalidator:
    'केवल अक्षर और रिक्त स्थान हों, एक अक्षर से शुरू होना चाहिए और 28 से अधिक अक्षर नहीं होने चाहिए',
  accountNum: 'खाता संख्या',
  accountNumError: 'कृपया सही बैंक खाता संख्या दर्ज करें',
  IFSCCode: 'आईएफएससी कोड',
  IFSCCodeError:
    'कृपया सही आईएफएससी कोड दर्ज करें जिसमें पहले चार अंक बड़े अक्षरों में हों और पांचवां अंक 0 होना चाहिए',
  toVerify: 'सत्यापित के लिए',
  verifyCodeError: 'ओटीपी दर्ज करें',
  reqOpt: 'ओटीपी का अनुरोध करें',
  submit: 'जमा करना',
  delete: 'मिटाना',
  save: 'सहेजें',
  delsuccess: 'हटाना सफल',
  hot: 'हॉट',
  amazongiftcard: 'अमेज़न गिफ्ट कार्ड',
  giftcarduse: 'गिफ्ट कार्ड उपयोग गाइड',
  howtouse: 'अमेज़न गिफ्ट कार्ड का उपयोग कैसे करें?',
  step1: 'चरण 1',
  'step1desc-1': '',
  'step1desc-2': 'वेबसाइट पर जाएं या Amazon ऐप डाउनलोड करें;',
  step2: 'चरण 2',
  step2desc: "अपना खाता या किसी अन्य की वर्ड 'गिफ्ट कार्ड' गिफ्ट कार्ड पर क्लिक करें;",
  step3: 'चरण 3',
  step3desc: 'अपनी शेष राशि में गिफ्ट कार्ड जोड़ें पर क्लिक करें;',
  step4: 'चरण 4',
  step4desc:
    'रिडीम करने के लिए गिफ्ट कार्ड कोड कॉपी करें, नंबर स्वचालित रूप से आपके खाते में जुड़ जाएगा।',
  disclaimer: 'उद्घोषणा',
  processing: 'प्रोसेसिंग',
  success: 'सफल',
  fail: 'असफल',
  withdrawalStatus: 'निकासी की स्थिति',
  withdrawalTime: 'निकासी शुरू होने का समय',
  code: 'कोड',
  withdrawalID: 'विथ्ड्रॉअल आईडी',
  expirationTime: 'समाप्ति समय',
  giftCard: 'गिफ्ट कार्ड',
  account: 'खाता',
  IFSC: 'IFSC',
  towhere: 'शेष वापसी',
  failReason: 'कारण',
  copySuccess: 'कॉपी सफल',
  copyFail: 'प्रतिलिपि विफल',
  redeemSuccess: 'रिडीम करना सफल',
  copy: 'कॉपी',
  desc: 'कृपया अपनी व्यक्तिगत संपत्ति के नुकसान से बचने के लिए गिफ्ट कार्ड कोड किसी के साथ साझा न करें, कृपया वैधता अवधि के अंदर जितनी जल्दी हो सके इसका उपयोग करें',
  done: 'हो गया',
  cancel: 'रद्द करना',
  close: 'बंद करना',
  redeemdetail: 'रिडीम विवरण',
  withdrawalMethod: 'विथ्ड्रॉअल विधि',
  notAvail: 'उपलब्ध नहीं है',
  add: 'जोड़ें',
  withAmount: 'विथ्ड्रॉअल राशि',
  withDraw: 'विथ्ड्रॉ',
  inputTips: 'विथ्ड्रॉअल विफलता से बचने के लिए कृपया सही बैंक जानकारी प्रदान करें',
  verifyCorrect: 'सत्यापित सही, विथ्ड्रॉ करें',
  addTitle: 'विथ्ड्रॉअल विधि जोड़ें',
  editTitle: 'निकासी विधि संपादित करें',
  successInit: 'निकासी सफलतापूर्वक प्रारंभ की गई',
  successRequest: 'Withdrawal request submitted successfully',
  afterFirst: 'पहले आमंत्रण के बाद',
  get: 'इकट्ठा',
  congratulation: 'बधाई हो! अपने दोस्तों को एक साथ नकद कमाने के लिए आमंत्रित करने जाएं!',
  sharewith: 'दोस्तों के साथ शेयर करें',
  details: 'विवरण',
  withableAmount: 'विथ्ड्रॉ योग्य राशि', //可提现金额
  converting: 'विथ्ड्रॉ योग्य राशि में परिवर्तित करना',
  withdrawalThreshold: 'Withdrawal Threshold',
  togiftCard: 'गिफ्ट कार्ड के लिए',
  instant: 'तुरंत पहुँचें',
  nobankInfo: 'बैंक जानकारी नहीं चाहिए',
  tobankAccount: 'बैंक खाते में',
  viewMore: 'देखना',
  faq: 'सामान्य प्रश्न',
  redeemNow: 'अभी रिडीम करें',
  accountBlock: 'खाता अवरुद्ध! ',
  contactTas: ' विवरण के लिए कृपया Taurus ग्राहक सेवा से संपर्क करें।',
  noData: 'कोई डेटा नहीं',
  withdrawThres: 'विथ्ड्रॉ सीमा',
  withdrawThres1: 'िकासी योग्य राशि निकालने के लिए ₹{amount} तक पहुंचती है',
  dearUser: 'प्रिय उपयोगकर्ता',
  descdearUser:
    'हमारे ऑनलाइन कमाई मंच की ओर से शुभकामनाएँ! हम आपको हमारे समुदाय के एक मूल्यवान सदस्य के रूप में पाकर खुश हैं, और हमें उम्मीद है कि आप टास्कस और गतिविधियों को पूरा करके रिवार्डस अर्जित करने के विभिन्न अवसरों का आनंद ले रहे हैं। आज, हम आपको हमारी विथ्ड्रॉ सीमा के संबंध में महत्वपूर्ण जानकारी प्रदान करना चाहते हैं।',
  withRecord: 'विथ्ड्रॉअल रिकॉर्ड',
  myAsset: 'मेरी संपत्ति',
  record: 'अभिलेख',
  know: 'अच्छा ऐसा है',
  sendOptmsg: 'आपके मोबाइल फोन पर आपको ओटीपी भेजा गया था',
  bank: 'किनारा',
  inputPhoneTip: 'फोन नंबर दर्ज',
  inputAcnameTip: 'खाताधारक का नाम दर्ज करें',
  inputAcnueTip: 'खाता संख्या दर्ज करें',
  inputifCodeTip: 'आईएफएससी कोड दर्ज करें',
  inputVerifyCodeTip: 'कृपया दर्ज करें',
  sendreqTip: 'आपके मोबाइल फ़ोन पर OTP भेजा गया है',
  redeemGift: 'गिफ्ट कार्ड रिडीम करें',
  eyeTips:
    'स्क्रीनशॉट लेते समय या स्क्रीन रिकॉर्ड करते समय, धन हानि से बचने के लिए कार्ड पासवर्ड छिपाया जाना चाहिए।',
  feedback: 'प्रतिक्रिया',
  viewfeedback: 'प्रतिक्रिया देखें',
  commonPro: 'आम समस्या',
  one: 'एक',
  two: 'दो',
  problem: {
    'pro-1-1': '"निकासी योग्य राशि में परिवर्तित करना" क्या है?',
    'pro-1-2': '1. बदली जाने वाली आपकी राशि आपके खाते की सारी नकदी है।',
    'pro-1-3':
      '2. आपके पास बदली जाने के लिए जितनी अधिक राशि होगी, आप उतनी ही अधिक विथ्ड्रॉ योग्य राशि प्राप्त कर सकते हैं।',
    'pro-1-4': 'हम "निकासी योग्य राशि में परिवर्तित करके" अधिक कैसे कमा सकते है?',
    'pro-1-5': '1. होमपेज गेमस को अपने दोस्तों के साथ सफलतापूर्वक साझा करें।',
    'pro-1-6': '2. अपने दोस्तों के साथ Taurus को सफलतापूर्वक साझा करें।',
    'pro-1-7': 'राशि को जल्दी से विथ्ड्रॉ लायक राशि में कैसे बदलें?',
    'pro-1-8': '1. अपने दोस्तों के साथ होमपेज गेमस साझा करें',
    'pro-1-9': '2. होमपेज़ के टास्कस पूरे करें',
    'pro-1-10': '3. लेवल.3 में अपग्रेड करने के बाद एक मेंटोर के लिए आवेदन करें।',
    'pro-1-11': 'और देखें',
    'pro-1-12':
      'प्रश्न: निकासी योग्य राशि और "निकासी योग्य राशि में परिवर्तित होने" के बीच क्या संबंध है?',
    'pro-1-13':
      '1. बदली जाने वाली राशि Taurusही आपकी कुल संपत्ति है, और विथ्ड्रॉ योग्य राशि बदली जाने वाली राशि से आती है।',
    'pro-1-14':
      '2. आपको अपनी राशि को विथ्ड्रॉ योग्य राशि में बदलने जाने की जरूरत है, फिर आप सफलतापूर्वक विथ्ड्रॉ कर सकते हैं। आपके पास बदलनी जाने के लिए जितनी अधिक राशि होगी, आप उतनी ही अधिक विथ्ड्रॉ योग्य राशि प्राप्त कर सकते हैं।',
    'pro-1-15': '3. आप अपनी विथ्ड्रॉ योग्य नकदी को निम्नलिखित तरीकों से बदल सकते हैं',
    'pro-1-16':
      'गेम को होमपेज पर अपने दोस्तों के साथ साझा करें, और आपके दोस्तों को गेम में सक्रिय रहना होगा।',
    'pro-1-17': 'रिवार्डस प्राप्त करने के लिए होमपेज़ पर टास्कस को पूरा करें',
    'pro-1-18': 'लेवल.3 के बाद प्लेटफ़ॉर्म द्वारा प्रदान किए गए एक सलाहकार के लिए आवेदन करें',
    'pro-1-19':
      'प्र. मैं "निकासी योग्य राशि में परिवर्तन" को शीघ्रता से निकासी योग्य नकदी में कैसे परिवर्तित कर सकता हूं?',
    'pro-1-20':
      'अपने पसंदीदा सोशल सॉफ़्टवेयर के माध्यम से गेम को होमपेज पर अपने दोस्तों के साथ साझा करें',
    'pro-1-21': 'अपने दोस्तों को सिखाएं कि यह गेम कैसे खेलें और पैसे कमाएं',
    'pro-1-22':
      'आपके दोस्त गेम में सक्रिय रहें, और आपकी नकदी धीरे-धीरे विथ्ड्रॉ योग्य राशि में बदल जाएगी।',
    'pro-1-23': 'प्र. विथ्ड्रॉअल सीमा क्या है?',
    'pro-1-24':
      '1. चूंकि बैंक ट्रांसफ़र के लिए प्रोसेसिंग शुल्क में कटौती की जरूरत होती है, इसलिए आपके नुकसान से बचने के लिए, Taurus फेजद विथ्ड्रॉअल विधि लागू करता है और सभी प्रोसेसिंग शुल्क वहन करेगा।',
    'pro-1-25': '2. यह आपको अपनी आय को लचीले ढंग से प्रबंधित करने की अनुमति देता है।',
    'pro-1-26':
      '3. केवल 6 विथ्ड्रॉअल सीमाएँ हैं। उच्चतम सीमा तक पहुंचने के बाद, विथ्ड्रॉअल की कोई सीमा नहीं होगी।',
    'pro-1-27': 'विथ्ड्रॉअल सीमा',
    'pro-1-28': 'हम इस सीमा तक जल्दी कैसे पहुंच सकते हैं?',
    'pro-1-29': 'नौसिखिए टास्कस को पूरा करें',
    'pro-1-30': 'गेम में टास्कस को पूरा करें',
    'pro-1-31': 'एक मेंटोर के लिए आवेदन करें',
    'pro-1-32': 'गेम को अपने दोस्तों के साथ साझा करें',
    'pro-1-33': 'अपने दोस्तों के साथ Taurusसाझा करें',
    'pro-1-34': 'Taurus संरक्षक बनें',
    'pro-1-35': 'प्र. मैं कैसे पुष्टि करूं कि मेरी संपत्ति विथ्ड्रॉ योग्य राशि में बदल दी गई है?',
    'pro-1-36':
      'जब आपकी नकदी विथ्ड्रॉ योग्य राशि में बदल जाती है, तो Taurus सहायक आपको एक अधिसूचना भेजेगा।',
    'pro-1-37':
      'आप [कमीशन विवरण] जांचने के लिए प्रोफ़ाइल फोटो पर भी क्लिक कर सकते हैं और फिर कमीशन के स्रोत की जांच करने के लिए [निकासी योग्य विवरण] पर जा सकते हैं।'
  },
  problemTypes: 'समस्या के प्रकार',
  problemTypesSelect: 'कृपया समस्या प्रकार चुनें',
  problemType: {
    'pro-1': '3 दिनों से अधिक समय तक प्रसंस्करण',
    'pro-2': 'सफल लेकिन श्रेय नहीं मिला',
    'pro-3': 'असफल रहा लेकिन खाते में वापस नहीं किया गया',
    'pro-4': 'अन्य'
  },
  issueDetails: 'Iमुद्दे का विवरण',
  issueDetailsEnter: 'कृपया मुद्दे का विवरण दर्ज करें',
  uploadBank: 'बैंक स्टेटमेंट या सबूत अपलोड करें',
  uploadBankEnter: 'कृपया बैंक स्टेटमेंट या सबूत अपलोड करें',
  uploadTip:
    'पीडीएफ और जेपीजी अपलोड करने का समर्थन करता है, 3 से अधिक चित्र नहीं, और 10M फ़ाइल आकार से अधिक नहीं',
  upload: 'डालना',
  image: 'चित्र',
  file: 'दस्तावेज़',
  uploadFileTip: 'पीडीएफ प्रारूप में बैंक विवरण अपलोड करें (10 मिलियन के भीतर)',
  uploadImageTip: 'कम से कम एक चित्र अपलोड करें',
  limitImageTip: 'अधिकतम 3 चित्र अपलोड हो रहे हैं',
  limitFileTip: '1 फ़ाइल तक अपलोड हो रहा है',
  sumitsuccess: 'सफलतापूर्वक जमा',
  USER_PROCESSING: 'फीडबैक सफल, ग्राहक सेवा प्रसंस्करण की प्रतीक्षा है',
  CUSTOMER_PROCESSING: 'ग्राहक सेवा ने उत्तर दिया',
  FINISHED: 'ग्राहक सेवा प्रसंस्करण पूर्ण हुआ',
  USER_PROCESSING_OUT: 'फीडबैक सफल, ग्राहक सेवा प्रसंस्करण की प्रतीक्षा है',
  CUSTOMER_PROCESSING_OUT: 'ग्राहक सेवा प्रतिक्रिया प्रसंस्करण',
  FINISHED_OUT: 'पुरा होना।',
  feedbacked: 'प्रतिक्रिया दी गई',
  feedbackProcess: 'फीडबैक प्रक्रिया',
  customerServiceFeedback: 'ग्राहक सेवा प्रतिक्रिया',
  userFeedback: 'निकासी सीमा',
  waitingForUserFeedback: 'उपयोगकर्ता की प्रतिक्रिया का इंतजार है',
  waitingForServiceFeedback: 'ग्राहक सेवा प्रतिक्रिया की प्रतीक्षा है',
  safetyVerification: 'सुरक्षा सत्यापन',
  safetyVerificationTip:
    'परिसंपत्ति हानि से बचने के लिए, कृपया पुष्टि करें कि आप स्वयं ही निकासी कर रहे हैं',
  safetyVerificationMsg: 'हम आपके मोबाइल फोन पर ओटीपी भेजेंगे',
  unReceiveOTP: 'ओटीपी नहीं मिला?',
  resend: 'पुन: भेजें',
  clickGo: 'जाने के लिए क्लिक करें',
  suggestion: 'या उपहार कार्ड का उपयोग करें, 100% सफलतापूर्वक आ गए',
  go: 'जाना',
  verifyPlachoder: 'कृपया सत्यापन कोड दर्ज करें',
  tab1: 'सभी',
  tab2: 'काम',
  tab3: 'आमंत्रण',
  tab4: 'छूट',
  tab5: 'अन्य',
  tab6: 'अन्य गेम',
  title: 'आयोग का विवरण',
  notice: 'कमिशन रिकॉर्ड में देरी हो रही है, कृपया कल जांचें',
  selopt1: 'विथ्ड्रॉ योग्य विवरण',
  selopt2: 'विथ्ड्रॉ योग्य विवरण में बदलना',
  noMore: 'और नहीं',
  comop: 'Commission Options',
  comop1: 'विथ्ड्रॉ योग्य विवरण',
  comop2: 'विथ्ड्रॉ योग्य विवरण में बदलाव',
  select: 'चुनें',
  tips: 'टिप्स',
  tipMsg: 'कमिशन विवरण केवल 20 जून, 2023 के बाद दर्ज किए जाएंगे',
  tipMsg21: '1. कमीशन छूट विवरण में देरी हो रही है, कृपया कुछ दिनों के बाद दोबारा जांच करें।',
  tipMsg22: '2. कमिशन का विवरण केवल 20 जून 2023 के बाद का डेटा दिखाने के लिए दर्ज किया गया है।',
  pullTxt: 'ताज़ा करने के लिए नीचे खींचो...',
  loosingTxt: 'ताज़ा होने के लिए छोड़ दें...',
  loadingTxt: 'लोड हो रहा है...',
  successTxt: 'सफलतापूर्वक रीफ्रेश करें',
  errorTxt: 'अनुरोध विफल, पुनः लोड करने के लिए नीचे खींचें',
  notaskHis: 'अब कोई ऐतिहासिक आय नहीं है।',
  doTask: 'काम करो',
  guideTip: 'कमीशन प्रकार बदलने के लिए क्लिक करें',
  noticeBarText:
    '🚀💰 200%-300% Taurus कमीशन छूट वृद्धि और Taurus आमंत्रण पुरस्कार अब से दोगुना! 🔥💥',
  before: 'पहले',
  contact: 'Contact'
}
